import { expectedDocuments } from 'data/mock-data';

const mock = () => ({
  data: { ...expectedDocuments },
});

export default mock;
